
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timeline",
      function () {
        return require("private-next-pages/timeline/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timeline"])
      });
    }
  